export default __webpack_public_path__ + "static/media/banner.6c5f8d89.svg";